import FullEnviroHomepageMockup from "./FullEnviroHomepageMockup";
export default function App() {
  return <FullEnviroHomepageMockup />;
}